// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/dashboard_service.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { DashboardService } from "./dashboard_service_pb";

/**
 * @generated from rpc chalk.server.v1.DashboardService.CreateDashboard
 */
export const createDashboard = DashboardService.method.createDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.GetDashboard
 */
export const getDashboard = DashboardService.method.getDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.ListDashboards
 */
export const listDashboards = DashboardService.method.listDashboards;

/**
 * @generated from rpc chalk.server.v1.DashboardService.UpdateDashboard
 */
export const updateDashboard = DashboardService.method.updateDashboard;

/**
 * Owner-only, enforced in the handler; the annotation is just the coarse gate.
 *
 * @generated from rpc chalk.server.v1.DashboardService.UpdateDashboardSharing
 */
export const updateDashboardSharing = DashboardService.method.updateDashboardSharing;

/**
 * @generated from rpc chalk.server.v1.DashboardService.DeleteDashboard
 */
export const deleteDashboard = DashboardService.method.deleteDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.ExportDashboard
 */
export const exportDashboard = DashboardService.method.exportDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.ImportDashboard
 */
export const importDashboard = DashboardService.method.importDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.GetContextualDashboard
 */
export const getContextualDashboard = DashboardService.method.getContextualDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.UpsertContextualDashboard
 */
export const upsertContextualDashboard = DashboardService.method.upsertContextualDashboard;

/**
 * @generated from rpc chalk.server.v1.DashboardService.ResetContextualDashboard
 */
export const resetContextualDashboard = DashboardService.method.resetContextualDashboard;
